export default [
  {
    text: 'Dashboards & Reports',
    isHeader: true,
  },
  {
    to: { name: 'salesTrend' },
    icon: 'fa fa-chart-line',
    text: 'Salestrend',
  },
  {
    to: { name: 'reports' },
    icon: 'fa fa-file-excel',
    text: 'Reports',
  },
  {
    v3Link: '/inventory',
    icon: 'fa fa-file-invoice',
    text: 'Inventory',
  },
  {
    text: 'Products',
    isHeader: true,
  },
  {
    v3Link: '/products',
    icon: 'fa fa-box',
    text: 'Products',
  },
  {
    to: { name: 'orders' },
    icon: 'fa fa-shopping-cart',
    text: 'Orders',
  },
  {
    to: { name: 'invoices' },
    icon: 'fa fa-receipt',
    text: 'Invoices',
  },
  {
    v3Link: '/giftcards',
    icon: 'fa fa-credit-card',
    text: 'Giftcards',
  },
  {
    to: { name: 'toplists' },
    icon: 'fa fa-stream',
    text: 'Toplists',
  },
  {
    v3Link: '/users',
    icon: 'fa fa-users',
    text: 'Users',
  },
  {
    text: 'Suppliers & Bookings',
    isHeader: true,
  },
  {
    v3Link: '/suppliers',
    icon: 'fa fa-people-carry',
    text: 'Suppliers',
  },
  {
    v3Link: '/suppliers-requests',
    icon: 'fa fa-user-edit',
    text: 'Requests',
    badgeGetter: 'supplierRequests/activeCount',
  },
  {
    to: { name: 'csvcodes' },
    icon: 'fa fa-file-csv',
    text: 'CSV Codes Batches',
  },
  {
    to: { name: 'csv-codes-containers' },
    icon: 'fa fa-file-csv',
    text: 'CSV Codes Containers',
  },
  {
    text: 'Locations',
    isHeader: true,
  },
  {
    v3Link: '/countries',
    icon: 'fa fa-location-arrow',
    text: 'Countries',
  },
  {
    text: 'Misc',
    isHeader: true,
  },
  {
    to: { name: 'pages' },
    icon: 'fa fa-file-alt',
    text: 'Pages',
  },
  {
    to: { name: 'inspirations' },
    icon: 'fa fa-file-signature',
    text: 'Inspirations',
  },
  {
    v3Link: '/categories',
    icon: 'fa fa-layer-group',
    text: 'Categories',
  },
]
